export default __webpack_public_path__ + "static/7a4904bf-0ae0-40e7-a607-d47e11a9b740-93d153813611880b1d0f2576fcadd071.woff2";